export const DEVICEGRAPH_TIMEFRAME = {
  "15D": "15D",
  "7D": "7D",
  "1D": "1D",
  "1H": "1H",
  LIVE: "LIVE"
} as const
